import { Component, computed, input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslatePipe } from '@ngx-translate/core';

export interface ErrorResult {
  status: string;
  message: string;
  fallbackMessage?: string;
  validationErrors?: string;
}

_('error.UsernameExistsException');
_('error.FailedAuthenticationException');
_('error.CodeDeliveryFailureException');
_('error.LimitExceededException');
_('error.InvalidPasswordException');
_('error.InvalidPasswordFormatException');
_('error.InternalErrorException');
_('error.AWSCognitoIdentityProviderException');
_('error.ForbiddenException');
_('error.PasswordResetRequiredException');
_('error.PreconditionNotMetException');
_('error.UnauthorizedException');
_('error.UserNotConfirmedException');
_('error.AccessDeniedException');
_('error.NoSuchElementException');
_('error.ResourceNotFoundException');
_('error.ResourceAlreadyExists');
_('error.MailSendException');
_('error.ConstraintViolationException');
_('error.BadRequestException');
_('error.IllegalArgumentException');
_('error.UserNotFoundException');
_('error.JsonParseException');
_('error.UnsupportedDataTypeException');
_('error.MethodNotAllowedException');
_('error.JiraServiceDeskException');
_('error.MultipleUsersFoundException');
_('error.UserCreationException');
_('error.KeycloakException');
_('error.MailException');
_('error.TooManyRequestsException');
_('error.custom.no_active_job');
_('error.custom.cannot_delete_self');
_('error.custom.cannot_delete_admin');
_('error.custom.cannot_change_admin_role');
_('error.custom.cannot_change_email');
_('error.custom.email_already_exists');
_('error.custom.email_already_verified');
_('error.custom.user_or_org_not_verified');
_('error.custom.invalid_activation_code');
_('error.custom.export_sync_limit_exceeded');
_('error.custom.export_sync_date_range_exceeded');
_('error.WorkflowIdentifierAlreadyExists');

_('httperror.0');
_('httperror.400');
_('httperror.401');
_('httperror.403');
_('httperror.404');
_('httperror.405');
_('httperror.406');
_('httperror.407');
_('httperror.408');
_('httperror.409');
_('httperror.410');
_('httperror.411');
_('httperror.412');
_('httperror.413');
_('httperror.414');
_('httperror.415');
_('httperror.416');
_('httperror.417');
_('httperror.418');
_('httperror.419');
_('httperror.420');
_('httperror.422');
_('httperror.429');
_('httperror.500');
_('httperror.501');
_('httperror.503');
_('httperror.502');

@Component({
  standalone: true,
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  imports: [TranslatePipe],
})
export class ErrorComponent {
  error = input<HttpErrorResponse>();

  errorObject = computed<ErrorResult>(() => {
    const body = this.error()?.error;
    const backendMessage = [body?.exc_message, body?.message].find(
      (message): message is string =>
        typeof message === 'string' && !!message.trim(),
    );
    if (this.error()?.error?.error !== undefined) {
      return {
        status: this.error()!.status.toString(),
        message: this.error()!.error.error,
        fallbackMessage: backendMessage,
        validationErrors: this.error()!.error.validationErrors || '',
      };
    } else if (backendMessage) {
      return {
        status: this.error()!.status.toString(),
        message: backendMessage,
        fallbackMessage: backendMessage,
      };
    } else if (this.error()?.status !== undefined) {
      return {
        status: this.error()!.status.toString(),
        message: `httperror.${this.error()!.status}`,
      };
    } else if (this.error()?.message !== undefined) {
      return {
        status: '',
        message: this.error()!.message,
      };
    } else {
      return {
        status: '',
        message: 'error.unknown',
      };
    }
  });
}
